import { useMemo } from "react"

import { useWindowSize } from "src/hooks/use_window_size"

export const useResponsiveView = (columns, viewOverride = null) => {
  const { isXLScreen } = useWindowSize()

  const hasCardRoles = useMemo(
    () => columns.some((col) => col.cardRole),
    [columns]
  )

  const responsiveShowsCards = !isXLScreen && hasCardRoles

  const shouldShowCards =
    viewOverride === "cards"
      ? hasCardRoles
      : viewOverride === "table"
      ? false
      : responsiveShowsCards

  return { shouldShowCards }
}
